import api from './api.ts';

export enum VesselStatus {
  IN_STOCK = 'in_stock',
  SOLD = 'sold',
  RESERVED = 'reserved',
  EXCHANGED = 'exchanged',
}

export type VesselCategory = 'boat' | 'yacht' | 'sailboat' | 'other';

export interface Vessel {
  id: number;
  make: string;
  model: string;
  year: number;
  registrationNumber: string;
  color: string;
  purchasePrice: number;
  sellingPrice: number | null;
  status: VesselStatus;
  category?: VesselCategory;
  purchaseDate: string;
  soldDate?: string | null;
  assetId?: number | null;
  attachments?: any[];
  createdAt?: string;
  updatedAt?: string;
}

export interface VesselPayload {
  make: string;
  model: string;
  year: number;
  registrationNumber: string;
  color: string;
  purchasePrice: number;
  sellingPrice: number | null;
  category?: VesselCategory;
  purchaseDate: string;
  soldDate?: string | null;
  assetId?: number | null;
  attachments?: any[];
}

export const VesselsAPI = {
  list: async (): Promise<Vessel[]> => {
    const res = await api.get('/vessels');
    return res.data;
  },
  get: async (id: number): Promise<Vessel> => {
    const res = await api.get(`/vessels/${id}`);
    return res.data;
  },
  create: async (payload: VesselPayload): Promise<Vessel> => {
    const res = await api.post('/vessels', payload);
    return res.data;
  },
  update: async (id: number, payload: Partial<VesselPayload>): Promise<Vessel> => {
    const res = await api.put(`/vessels/${id}`, payload);
    return res.data;
  },
  delete: async (id: number): Promise<{ deleted: boolean }> => {
    const res = await api.delete(`/vessels/${id}`);
    return res.data;
  },
  sell: async (
    id: number,
    saleData: { sellingPrice: number; soldDate?: string }
  ): Promise<Vessel> => {
    const res = await api.put(`/vessels/${id}/sell`, saleData);
    return res.data;
  },
  history: async (id: number): Promise<any[]> => {
    const res = await api.get(`/vessels/${id}/history`);
    return res.data;
  },
};
